import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/core/services/loader.service';
import { UtilsService } from 'src/core/services/utils.service';


@Component({
    selector: 'core-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss'],
    standalone: false
})
export class MainNavComponent implements OnInit, AfterViewInit {
  isLoading: boolean = false;

  constructor(
    private loaderService: LoaderService,
    private utils: UtilsService
    ) { }

  ngOnInit(): void {
    this
    .loaderService
    .isLoading
    .subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  ngAfterViewInit(): void {
    const mainNav = document.querySelector('#main-nav') as HTMLElement;
    this.utils.watchMainNavHeight(mainNav);
  }
}
